import { DEFAULT_ROLES, ROLE_ORDER } from "./organigramaDefaultData";
import { roleAccent } from "./organigramaColors";

const STRUCTURE_KEYS = new Set(["id", "section", "name", "accent"]);
const SUPPORTED_LOCALES = new Set(["en", "es", "ch", "dk", "nl"]);

const isRoleContent = (value) =>
  value && typeof value === "object" && !Array.isArray(value) && Object.keys(value).length > 0;

export const normalizeOrganigramaLocale = (lng) => {
  const base = String(lng || "en").split("-")[0].toLowerCase();
  return SUPPORTED_LOCALES.has(base) ? base : "en";
};

/** Extrae solo campos editables (sin id, section, name, accent). */
export const extractRoleContent = (role) => {
  if (!role) return {};
  const content = {};
  Object.entries(role).forEach(([key, value]) => {
    if (!STRUCTURE_KEYS.has(key)) {
      content[key] = JSON.parse(JSON.stringify(value));
    }
  });
  return content;
};

export const extractAllRolesContent = (rolesByKey = {}) => {
  const content = {};
  ROLE_ORDER.forEach((key) => {
    if (rolesByKey[key]) {
      content[key] = extractRoleContent(rolesByKey[key]);
    }
  });
  return content;
};

/**
 * Prioridad por idioma: guardado en servidor > i18n por defecto > estructura base.
 */
export const resolveDisplayRoles = (savedLocales, locale, t) => {
  const normalized = normalizeOrganigramaLocale(locale);
  const savedForLocale = savedLocales?.[normalized] || {};
  const resolved = {};

  ROLE_ORDER.forEach((key) => {
    const defaults = JSON.parse(JSON.stringify(DEFAULT_ROLES[key]));
    const i18nRole = t(`organigrama.roles.${key}`, { returnObjects: true });
    const savedRole = savedForLocale[key];

    resolved[key] = {
      ...defaults,
      ...(isRoleContent(i18nRole) ? i18nRole : {}),
      ...(isRoleContent(savedRole) ? savedRole : {}),
      id: defaults.id,
      section: defaults.section,
      name: defaults.name,
      accent: roleAccent(key),
    };
  });

  return resolved;
};

/** Migra formato antiguo (roles plano) a locales.en */
export const normalizeSavedLocales = (payload = {}) => {
  if (payload?.locales && typeof payload.locales === "object") {
    return JSON.parse(JSON.stringify(payload.locales));
  }
  if (payload?.roles && typeof payload.roles === "object") {
    return { en: extractAllRolesContent(payload.roles) };
  }
  return {};
};
